<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process !== 'next_actions'">
			<div class="portlet-title">
				<div class="caption">
					Create A Region
				</div>
			</div>
			<div class="portlet-body portlet-overflow">
				<form role="form" @submit.prevent="createRegion($event)" novalidate>
					<div class="alert alert-danger" v-if="errorMessage.length">
						<button class="close" data-close="alert" @click="clearError()"></button>
						<span>{{ errorMessage }}</span>
					</div>
					<transition name="fade" mode="out-in">
						<div v-if="process === 'step_1'" key="step_1">
							<div class="form-body invite-user-form">
								<div class="form-group form-md-line-input form-md-floating-label">
									<input type="text" class="form-control input-sm" :class="{'edited': newRegion.region_name.length}" id="create_region_name" v-model.trim="newRegion.region_name">
									<label for="create_region_name">Region Name</label>
								</div>
							</div>
							<div class="form-actions noborder invite-user-actions">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()">Return To Regions Dashboard</button>
								<button type="submit" class="btn blue" key="create-location-confirm">Submit </button>
							</div>
						</div>
					</transition>
				</form>
			</div>
		</div>
		<next-actions v-else :actionsList="createRegionNextActions" @runFunction="runFunction"></next-actions>
	</div>
</template>
<script>
import GlobalFunctions from '../../../../global'
import Region from '../../../../controllers/Region'
import NextActions from '../../../modules/NextActions'
import { mapGetters } from 'vuex'

/**
 * Create Region module is a page for creating new regions.
 * @class CreateRegion
 * @extends Region
 * @since 0.0.8
 */

export default {
	name: 'create-region',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			newRegion: {
				region_name: ''
			},
			createRegionNextActions: [{title: 'Return to Regions Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel'}]
		}
	},
	/**
	 * Run on `created` to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof CreateRegion
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === 'My Business Regions - Create Region') {
			this.activePanel = true
		}
	},
	computed: mapGetters([
		'activeBusinessId'
	]),
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRegion
		 * @version 0.0.8
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To close the create region panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRegion
		 * @version 0.0.8
		 */
		closePanel () {
			this.process = 'step_1'
			this.$router.push('/app/my_business/regions')
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateREGION
		 * @version 0.0.8
		 */
		validateFormData () {
			let _this = this

			return new Promise((resolve, reject) => {
				if (_this.newRegion.region_name.length < 3) {
					reject('Region name must be as least 3 characters')
				}
				resolve()
			})
		},
		/**
		 * To send the details of the new region to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateRegion
		 * @version 0.0.8
		 */
		createRegion (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this
			let businessId = this.activeBusinessId
			return _this.validateFormData().then(response => {
				_this.clearError()
				let parentId
				if (_this.$router.parent_id) {
					parentId = _this.$router.parent_id
				}
				Region.createRegion(businessId, _this.newRegion.region_name, parentId).then(response => {
					_this.clearForm()
					_this.process = 'next_actions'
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					console.log(e)
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				if (reason) {
					_this.errorMessage = reason
				}
				disabledButton.cancel()
			})
		},
		/**
		 * To clear the object 'newRegion'.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRegion
		 * @version 0.0.9
		 */
		clearForm () {
			this.newRegion = {
				region_name: ''
			}
		},
		/**
		 * To run the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof CreateRegion
		 * @version 0.0.9
		 */
		runFunction (functionName, params) {
			if (!params) {
				this[functionName]()
			} else {
				this[functionName](params[0])
			}
		}
	},
	components: {
		NextActions
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof CreateRegion
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === 'My Business Regions - Create Region') {
				this.activePanel = true
				this.process = 'step_1'
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// CreateRegion.vue?2642d3c2